import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { DataHelper } from '@helpers/data.helper';

import { timer } from 'rxjs';
import { removeUniquePipe } from '@pipes/reducer.pipe';
import tisos from '@pipes/countryiso.json';

@Component({
  selector: 'league-filter-component',
  templateUrl: '../sharedTemplates/league.filter.component.html',
})
export class LeagueFilterComponent {
  leagueData;
  _liveFilterItems;
  countriesiso;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _MatBottomSheet: MatBottomSheet,
    private bottomSheetRef: MatBottomSheetRef<LeagueFilterComponent>,
    private _DataHelper: DataHelper
  ) {
    const leagueFilteredData = JSON.parse(localStorage.getItem('league-filter-data'));

    if (leagueFilteredData != null && leagueFilteredData.length > 0) {
      this._DataHelper.setLiveFilterItems(leagueFilteredData);
      this._liveFilterItems = leagueFilteredData;
    }
  }

  clearAction() {
    localStorage.setItem('league-filter-data', JSON.stringify([]));
    this._DataHelper.setLiveFilterItems([]);
    this.closeBottomSheet();
  }
  dataChanged(e, l) {
    const a = this.leagueData
      .filter(x => x['isCheckedByFilter'])
      .map(y => {
        return y.GroupName;
      });

    localStorage.setItem('league-filter-data', JSON.stringify(a));

    this._DataHelper.setLiveFilterItems(a);
    this._liveFilterItems = a;
  }

  checkItemOnAction() {
    this.leagueData = this.leagueData.map(x => {
      if (this._liveFilterItems) {
        if (this._liveFilterItems.length > 0) {
          ////console.log(this._liveFilterItems);
          x['isCheckedByFilter'] = this._liveFilterItems.includes(x.GroupName);
        } else {
          x['isCheckedByFilter'] = false;
        }
      } else {
        x['isCheckedByFilter'] = false;
      }

      return x;
    });
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

  ngAfterViewInit() {
    this.leagueData = this._DataHelper.liveEventDataRebuildedUnfiltered;
    //////console.log('gelen data',this.leagueData);
    this._DataHelper.liveEventDataRebuildedListenerUnfiltered.subscribe(x => {
      // this.leagueData = x;
      //////console.log('gelen data',this.leagueData);
      //  this.checkItemOnAction();
    });
    this._liveFilterItems = this._DataHelper.liveFilterItems;
    /*
    this._DataHelper.liveFilterItemsListener.subscribe((x) => {
      this._liveFilterItems = x;
      this.checkItemOnAction();

    });
    */
    this.checkItemOnAction();
    this.countriesiso = tisos;
  }

  getIso(catId) {
    const t_country = this.countriesiso.countries.filter(s => s.catid == catId);
    if (t_country != undefined) {
      if (t_country[0] != undefined) return t_country[0].iso;
      else return 'un';
    } else return 'un';
  }
}
